/**
 *
 * Asynchronously loads the component for FlaggedReasonsDisplay
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/components/flagged-reasons-display/loadable.js